import { dataURLtoBlob } from '~core';

const downloadHelper = (filename, url) => {
  const element = document.createElement('a');

  element.setAttribute('href', url);
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  let clickHandler;
  element.addEventListener(
    'click',
    (clickHandler = function () {
      // ..and to wait a frame
      requestAnimationFrame(function () {
        URL.revokeObjectURL(element.href);
      });

      element.removeAttribute('href');
      element.removeEventListener('click', clickHandler);
    })
  );

  document.body.removeChild(element);
};

export const downloadSvg = (filename, svgString) => {
  const url =
    'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgString);

  downloadHelper(filename, url);
};

export const download = (filename, dataUrl, isblob) => {
  //TODO: eliminare quando non servirà più. attualmente non viene utilizzata
  let dataBlob;

  if (isblob) {
    dataBlob = dataUrl;
  } else {
    dataBlob = dataURLtoBlob(dataUrl);
  }

  const url = URL.createObjectURL(dataBlob);

  downloadHelper(filename, url);
};
